export default "/images/d9076780ebf9474ce0e20d8b7e1b5655.avif";